import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button } from 'devextreme-react/button';
import { formatMessage } from 'devextreme/localization';
import style from './holderreportcell.module.scss';
import PopupMVP from '../../PopupMVP';

const HolderReportCell = ({
  data,
  getPopupActReport,
  popupActReducer: {
    okRequest
  }
}) => {
  const [visiblePopup, setVisiblePopup] = useState(false);
  const [statusStyle, setStatusStyle] = useState('');

  const onHiding = () => {
    setVisiblePopup(false);
  };

  useEffect(() => {
    if (okRequest) {
      onHiding();
    }
  }, [okRequest]);

  /*  docStatus
  * 1: Создан
  * 2: Сформирован
  * 3: Отправлен
  * 4: Подписан
  * */
  useEffect(() => {
    const { data: { docStatus } } = data;

    switch (docStatus) {
      case 2:
        setStatusStyle(style.buttonNotSend);
        break;
      case 3:
        setStatusStyle(style.buttonSend);
        break;
      case 4:
        setStatusStyle(style.buttonSendOk);
        break;
      default:
        setStatusStyle('');
    }
  }, [data]);

  const getModalTitle = useMemo(() => {
    const { data: { docStatus } } = data;
    switch (docStatus) {
      case 2:
        return `${formatMessage('textModal').textBailorSendReport} №${data.value}?`;
      case 3:
      case 4:
        return `${formatMessage('textModal').textBailorSendReportSent} ${data.value}?`;
      default:
        return `${formatMessage('textModal').textHolderReport} №${data.value}`;
    }
  }, [data]);

  const onPreviewReport = useCallback(() => {
    const { data: { docNumId, docStatus } } = data;
    getPopupActReport({ idAct: docNumId, statusId: docStatus, type: 'HOLDEN_REPORT' });
  }, [data, getPopupActReport]);

  const onSignReport = useCallback(() => {
    const { data: { docNumId, docStatus } } = data;
    const status = docStatus === 2 ? 3 : docStatus;
    getPopupActReport({ idAct: docNumId, statusId: status, type: 'HOLDEN_REPORT' });
  }, [data, getPopupActReport]);

  const popupButtonRender = useMemo(() => {
    const { data: { docStatus } } = data;
    switch (docStatus) {
      case 1:
        return (
          <div className="formButton">
            <>
              <Button text={formatMessage('textButton').preview}
                      type="default"
                      stylingMode="contained"
                      width={200}
                      onClick={onPreviewReport}
              />
            </>
            <>
              <Button text={formatMessage('textButton').close}
                      type="default"
                      stylingMode="text"
                      onClick={onHiding}
              />
            </>
          </div>
        );
      case 2:
        return (
          <div className="formButton">
            <>
              <Button text={formatMessage('textButton').preview}
                      type="default"
                      stylingMode="contained"
                      width={200}
                      onClick={onPreviewReport}
              />
            </>
            <>
              <Button text={formatMessage('textButton').no}
                      type="default"
                      stylingMode="text"
                      onClick={onHiding}
              />
            </>
            <Button type="default"
                    stylingMode="contained"
                    width={200}
                    onClick={onSignReport}
                    visible
            >
              <span>{formatMessage('textButton').yes}</span>
            </Button>
          </div>
        );
      case 3:
      case 4:
        return (
          <div className="formButton">
            <>
              <Button text={formatMessage('textButton').preview}
                      type="default"
                      stylingMode="contained"
                      width={200}
                      onClick={onPreviewReport}
              />
            </>
            <>
              <Button text={formatMessage('textButton').close}
                      type="default"
                      stylingMode="text"
                      onClick={onHiding}
              />
            </>
          </div>
        );
      default:
        return <></>;
    }
  }, [data, onPreviewReport, onSignReport]);

  const renderPopup = useMemo(() => (
    <PopupMVP
        visible={visiblePopup}
        onHiding={onHiding}
        title={getModalTitle}
      >
      {popupButtonRender}
    </PopupMVP>
  ), [getModalTitle, popupButtonRender, visiblePopup]);
  const onClick = () => {
    setVisiblePopup(true);
  };
  return (
    <>
      <Button
        text={data.value}
        elementAttr={{ class: `${style.button}  ${statusStyle}` }}
        type="default"
        stylingMode="text"
        onClick={onClick}
      />
      {renderPopup}
    </>
  );
};

export default HolderReportCell;
